<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [queryParams]="{search: searchTerm}" [routerLink]="['/gateways']"><span translate>Gateway</span></a>
    </li>
    <li aria-current="page" class="breadcrumb-item active">
      <span translate>Configuration</span>:&nbsp;
      <span [innerText]="gatewayName"></span>
      <span [innerText]="' (S/N: ' + gateway.id + ')'"></span>
    </li>
  </ol>
</nav>

<div class="row">
  <div class="col-12 col-lg-auto mb-3 mb-lg-0">
    <div class="card nav-vertical">
      <div class="card-header">
        <em class="fa-solid fa-bars"></em>
        <span translate>Configuration</span>
      </div>
      <ul [(activeId)]="show" ngbNav (navChange)="onNavChange($event)" orientation="vertical">
        <li [disabled]="isLoadingGatewayDetails" [ngbNavItem]="menuItems.DETAILS">
          <a (click)="onMenuClick(menuItems.DETAILS)" ngbNavLink translate>Details</a>
        </li>
        <!-- NOT FOR CLOUDPLUG LIGHT-->
        @if (showConnectionTab) {
          <li [disabled]="isLoadingGatewayDetails" [ngbNavItem]="menuItems.CONNECTIONS">
            <a (click)="onMenuClick(menuItems.CONNECTIONS)" ngbNavLink translate>Connections</a>
          </li>
        }
        @if (isIotGateway()) {
          <li [disabled]="isLoadingGatewayDetails" [ngbNavItem]="menuItems.IOT_LOGS">
            <a (click)="onMenuClick(menuItems.IOT_LOGS)" ngbNavLink translate>Connectivity Logs</a>
          </li>
        }
        <!-- ONLY FOR CLOUDPLUG LIGHT-->
        @if (isCPLightGateway) {
          <li [disabled]="isLoadingGatewayDetails" [ngbNavItem]="menuItems.ADC">
            <a (click)="onMenuClick(menuItems.ADC)" ngbNavLink translate>ADC</a>
          </li>
        }
        @if (isCPLightGateway) {
          <li [disabled]="isLoadingGatewayDetails" [ngbNavItem]="menuItems.MODBUS">
            <a (click)="onMenuClick(menuItems.MODBUS)" ngbNavLink translate>Modbus</a>
          </li>
        }
        @if (isCPLightGateway) {
          <li [disabled]="isLoadingGatewayDetails" [ngbNavItem]="menuItems.GENERAL">
            <a (click)="onMenuClick(menuItems.GENERAL)" ngbNavLink translate>General</a>
          </li>
        }

        <!-- ONLY FOR CLOUDPLUG ONE, EDGE -->
        @if ((isCPOneGateway || isArgosGateway || isGenericGateway)) {
          <li [disabled]="isLoadingGatewayDetails"
              [ngbNavItem]="menuItems.FUNCTIONS">
            <a (click)="onMenuClick(menuItems.FUNCTIONS)" ngbNavLink translate>Functions</a>
          </li>
        }

        <!-- ONLY FOR CLOUDPLUG ONE -->
        @if (isCPOneGateway) {
          <li [disabled]="isLoadingGatewayDetails" [ngbNavItem]="menuItems.SERVICES">
            <a (click)="onMenuClick(menuItems.SERVICES)" ngbNavLink translate>Services</a>
          </li>
        }
        @if (isCPOneGateway) {
          <li [disabled]="isLoadingGatewayDetails" [ngbNavItem]="menuItems.LOGS">
            <a (click)="onMenuClick(menuItems.LOGS)" ngbNavLink translate>Logs</a>
          </li>
        }
        <li class="divider my-0"></li>

        <li [ngbNavItem]="menuItems.METADATA">
          <a (click)="onMenuClick(menuItems.METADATA)" ngbNavLink translate>Metainformation</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="col-12 col-lg">
    <div class="tab-container">

      @if (show === menuItems.DETAILS) {
        <scitis-admin-gateway-details
            [gateway]="gateway"
            [isArgosGateway]="isArgosGateway"
            [isCPEdgeGateway]="isCPEdgeGateway"
            [isCPLightGateway]="isCPLightGateway"
            [isCPOneGateway]="isCPOneGateway"
            [isCPSoftGateway]="isCPSoftGateway"
            [isGenericGateway]="isGenericGateway"
            [packages]="packages">
        </scitis-admin-gateway-details>
      }

      @if (show === menuItems.FUNCTIONS && (isCPOneGateway || isArgosGateway || isGenericGateway)) {
        <scitis-admin-gateway-functions
            [gateway]="gateway"
            [isArgosGateway]="isArgosGateway"
            [isCPEdgeGateway]="isCPEdgeGateway"
            [isCPLightGateway]="isCPLightGateway"
            [isCPOneGateway]="isCPOneGateway"
            [isCPSoftGateway]="isCPSoftGateway"
            [isGenericGateway]="isGenericGateway"
            [superAdminRole]="isSuperAdminRole"
            [superOrTechAdminRole]="superOrTechAdminRole">
        </scitis-admin-gateway-functions>
      }

      @if (show === menuItems.CONNECTIONS) {
        <scitis-admin-gateway-connections
            [gateway]="gateway"
            [isAdminOrHigher]="isAdminOrHigher"
            [isArgosGateway]="isArgosGateway"
            [isCPEdgeGateway]="isCPEdgeGateway"
            [isCPOneGateway]="isCPOneGateway"
            [isCPSoftGateway]="isCPSoftGateway"
            [isEditable]="isEditable"
            [isGenericGateway]="isGenericGateway"
            [superOrTechAdminRole]="superOrTechAdminRole">
        </scitis-admin-gateway-connections>
      }

      @if (show === menuItems.SERVICES) {
        <scitis-admin-gateway-service
            [gateway]=gateway
            [isAdminRole]="isAdminRole"
            [isSuperAdminRole]="isSuperAdminRole"
            [isTechAdminRole]="isTechAdminRole">
        </scitis-admin-gateway-service>
      }

      @if (show === menuItems.LOGS) {
        <scitis-admin-gateway-log
            [gateway]=gateway>

        </scitis-admin-gateway-log>
      }

      @if (show === menuItems.IOT_LOGS) {
        <scitis-admin-gateway-log-iot
            [gateway]=gateway>

        </scitis-admin-gateway-log-iot>
      }

      @if (show === menuItems.ADC) {
        <scitis-admin-gateway-adc
            (pushToIoTCoreEvent)="pushToIoTCore()"
            (saveConfigurationEvent)="saveConfiguration($event)"
            [gatewaySignals]="gatewaySignals"
            [gateway]="gateway"
            [isAdminRole]="isAdminRole"
            [isSuperAdminRole]="isSuperAdminRole"
            [isTechAdminRole]="isTechAdminRole">
        </scitis-admin-gateway-adc>
      }

      @if (show === menuItems.MODBUS) {
        <scitis-admin-gateway-modbus
            (pushToIoTCoreEvent)="pushToIoTCore()"
            (saveConfigurationEvent)="saveConfiguration($event)"
            [gatewaySignals]="gatewaySignals"
            [gateway]="gateway"
            [isAdminRole]="isAdminRole"
            [isSuperAdminRole]="isSuperAdminRole"
            [isTechAdminRole]="isTechAdminRole">
        </scitis-admin-gateway-modbus>
      }

      @if (show === menuItems.GENERAL) {
        <scitis-admin-gateway-general
            (pushToIoTCoreEvent)="pushToIoTCore()"
            (saveConfigurationEvent)="saveConfiguration($event)"
            [gatewaySignals]="gatewaySignals"
            [gateway]="gateway"
            [isAdminRole]="isAdminRole"
            [isSuperAdminRole]="isSuperAdminRole"
            [isTechAdminRole]="isTechAdminRole">
        </scitis-admin-gateway-general>
      }

      @if (show === menuItems.METADATA) {
        <scitis-admin-metadata
            [parent]="gateway"
            [type]="ELASTIC_SEARCH_TYPE.GATEWAY_META_DATA"
            [isAdminRole]="isAdminRole"
            [isSuperAdminRole]="isSuperAdminRole"
            [isTechAdminRole]="isTechAdminRole">

        </scitis-admin-metadata>
      }

    </div>
  </div>
</div>
